var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.41 425.41",
    style: {
      enableBackground: "new 0 0 425.41 425.41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 212.7072,
    x2: 425.4144,
    y2: 212.7072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B96D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#74CAEB"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 212.71,
    cy: 212.71,
    r: 212.71
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.27,190.41h-75.81c-2.46,0-4.46-2-4.46-4.46v-75.81c0-12.31-9.98-22.3-22.3-22.3 c-12.31,0-22.3,9.98-22.3,22.3v75.81c0,2.46-2,4.46-4.46,4.46h-75.81c-12.31,0-22.3,9.98-22.3,22.3c0,12.31,9.98,22.3,22.3,22.3 h75.81c2.46,0,4.46,2,4.46,4.46v75.81c0,12.31,9.98,22.3,22.3,22.3c12.31,0,22.3-9.98,22.3-22.3v-75.81c0-2.46,2-4.46,4.46-4.46 h75.81c12.31,0,22.3-9.98,22.3-22.3C337.57,200.39,327.59,190.41,315.27,190.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.70f8ea9ee7b5a1670dd42fa843ff2817.svg";
export { ForwardRef as ReactComponent };